@if (customer) {
<p-tabs [(value)]="tabIndex">
  <p-tablist>
    @if (customer?.id && hasCustomerDashboardAccess) {
    <p-tab [value]="0" ><i class="pi pi-home"></i></p-tab>
    }

    <p-tab [value]="1">Customer Info</p-tab>

    @if (!isCustomer && customer && customer.id) {
    <p-tab [value]="2">Internal Notes</p-tab>
    }
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel [value]="0">
      <app-customer-main-tab [customer]="customer"></app-customer-main-tab>
    </p-tabpanel>

    <p-tabpanel [value]="1">
      <app-customer-maintenance [customer]="customer"></app-customer-maintenance>
    </p-tabpanel>

    <p-tabpanel [value]="2">
      <app-customer-comments [customerIdInput]="customer.id" [claimNames]="claimNames"></app-customer-comments>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
}